export function getNode(id: string) {
  const singleLineSaved = localStorage.getItem("single-line-hywind");
  if (!singleLineSaved) {
    return;
  }

  const singleLine = JSON.parse(singleLineSaved);
  const turbine = singleLine.nodes.find(
    (turbine: any) => turbine?.data?.id === id,
  );

  return turbine?.data;
}
